"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustodialCryptoWalletSource = void 0;
/** @TranslateToRust */
var CustodialCryptoWalletSource;
(function (CustodialCryptoWalletSource) {
    CustodialCryptoWalletSource["BitGo"] = "BitGo";
    CustodialCryptoWalletSource["BitGoOmnibus"] = "BitGoOmnibus";
})(CustodialCryptoWalletSource || (exports.CustodialCryptoWalletSource = CustodialCryptoWalletSource = {}));
